module.exports = __webpack_public_path__ + "static/img/17.a689755f.jpeg";